import { WarrantyClaimStatus } from '@api/types';
import { TextCodes } from '@api/types/translation/TextCodes';
import { CustomTextField, Title, useWarrantyClaimContext } from '@components';
import { Box, Divider, Grid } from '@mui/material';
import { t } from '@translations';

export const WarrantyClaimDetailsSection = () => {
  const { warrantyData, form } = useWarrantyClaimContext();
  const invoiceNo = warrantyData?.invoiceNo;
  const reviewedBy = warrantyData?.reviewedBy;
  const status = warrantyData?.status ? t(TextCodes.Warranty.Status[warrantyData?.status]) : '';
  return (
    <Box>
      <Divider sx={{ my: 4 }} />
      <Title noDot variant='h3'>
        {t(TextCodes.Warranty.Block.WarrantyDetails)}
      </Title>
      <Grid container spacing={2} mt={4}>
        <Grid item xs={12} lg={8}>
          <Grid container rowSpacing={4} columnSpacing={2}>
            <Grid
              item
              xs={12}
              sm={6}
              md={
                warrantyData?.status === WarrantyClaimStatus.SentToVendorAndCredited
                  ? 4
                  : warrantyData?.status === WarrantyClaimStatus.SentToVendor
                  ? 3
                  : 2
              }
            >
              <CustomTextField
                label={t(TextCodes.Warranty.Block.Status)}
                value={status}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
            {reviewedBy && (
              <Grid item xs={12} sm={6} md={4}>
                <CustomTextField
                  label={t(TextCodes.Warranty.Block.ReviewedBy)}
                  value={reviewedBy}
                  InputProps={{
                    readOnly: true,
                  }}
                  {...form.register('reviewedBy')}
                />
              </Grid>
            )}
            {invoiceNo && (
              <Grid item xs={12} sm={6} md={2}>
                <CustomTextField
                  name='creditNote'
                  label={t(TextCodes.Warranty.Block.InvoiceNo)}
                  value={invoiceNo}
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};
